import { useAsyncValue, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useCart } from "../../../app/context/cart-context/cart-context";
import ApiServices from "../../../service/ApiServices";



export const LiqPay = () => {
    const navigate = useNavigate();

    const {clearCart} = useCart();

    const liqData = useAsyncValue();

    const res = new ApiServices();

    const isCheckoutInitiated = useRef(false);
    const orderStatus = useRef(false);

    useEffect(() => {
        if (!isCheckoutInitiated.current) { 
            window.LiqPayCheckout.init({
                data: liqData.data,
                signature: liqData.signature,
                embedTo: '#liqpay_checkout',
                language: 'ua',
                mode: 'embed'
            }).on("liqpay.callback", function(data){
                if (data.status === 'success' && !orderStatus.current) {
                    res.createOrder()
                    .then(data => {
                        if (data === 'Success') {
                            clearCart();

                            setTimeout(() => navigate('/'), 5000)
                        }
                    })  
                } else if (data.status === 'error' && !orderStatus.current ) {
                    setTimeout(() => navigate('/'), 5000)
                }
            }).on("liqpay.ready", function(data){
            }).on("liqpay.close", function(data){
               
                window.LiqPayCheckout.close();
            });
            isCheckoutInitiated.current = true;
        }
    }, [liqData]);

    return (
        <div id="liqpay_checkout"></div>
    )
}